import servicios from "./service.js"

let temporizadorInactividad;
export const esDispositivoMobil = ()  => {
    return /Mobi/i.test(navigator.userAgent);
}
const duracionInactividad = esDispositivoMobil() ? 10 * 60 * 1000 : 40 * 60 * 1000;

export const reiniciarTemporizadorInactividad = () =>  {
  let segundosInactividad = 0;
  clearTimeout(temporizadorInactividad);
  if (window.location.pathname !== '/LoginMaster') {
    temporizadorInactividad = setInterval(() => {
        segundosInactividad++;
        if (segundosInactividad * 1000 >= duracionInactividad) {
          servicios.CerrarSesion();
          clearInterval(temporizadorInactividad);
        }
      }, 1000);
  }
}

export const iniciarSeguimientoInactividad = () => {
  reiniciarTemporizadorInactividad();
  document.addEventListener('mousemove', reiniciarTemporizadorInactividad);
  document.addEventListener('keydown', reiniciarTemporizadorInactividad);
}



